import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";

interface NewsRowProps {
  item: NewsItem;
  showCover?: boolean;
}

export function NewsRow({ item, showCover = true }: NewsRowProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex cursor-pointer items-start gap-4 border-b border-background-200 py-4 last:border-b-0"
    >
      <div className="min-w-0 flex-1">
        <div className="mb-2 flex flex-wrap items-center gap-2 text-[11px]">
          <span className="rounded bg-accent-100 px-1.5 py-0.5 font-medium text-accent-800">
            {item.category}
          </span>
          <span className="font-label text-foreground-400">{item.date}</span>
        </div>
        <h3 className="line-clamp-2 text-[15px] font-medium leading-relaxed text-foreground-900 transition-colors group-hover:text-accent-700">
          {item.title}
        </h3>
        <p className="mt-1.5 line-clamp-1 text-xs text-foreground-500">
          {item.summary}
        </p>
      </div>

      {showCover && (
        <div className="hidden h-[76px] w-[112px] shrink-0 overflow-hidden rounded-md bg-background-200 sm:block">
          <img
            src={item.cover}
            alt={`${item.title} 配图`}
            title={`${item.title} 资讯配图`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
        </div>
      )}
    </Link>
  );
}

export function NewsFeaturedCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
    >
      <div className="relative h-[240px] w-full overflow-hidden bg-background-200 md:h-[280px]">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} 资讯配图`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded bg-accent-500 px-2 py-1 text-[11px] font-semibold text-primary-950">
          {item.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <span className="font-label text-xs text-foreground-400">{item.date}</span>
        <h3 className="mt-2 line-clamp-2 text-lg font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-accent-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <span className="mt-auto flex items-center gap-1 pt-4 text-xs font-medium text-primary-600">
          阅读全文
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}